(() => {
  'use strict';

  const LEGACY_PARAM = 'loop_bundle_id';
  if (window.__FTRLoopMetafieldRoutingInstalled) return;
  window.__FTRLoopMetafieldRoutingInstalled = true;

  const nativeReplaceState = window.history?.replaceState?.bind(window.history);

  function cleanUrl(value) {
    if (!value) return value;

    try {
      const isAbsolute = /^(?:https?:)?\/\//i.test(String(value));
      const url = new URL(value, window.location.origin);
      if (!url.searchParams.has(LEGACY_PARAM)) return value;

      url.searchParams.delete(LEGACY_PARAM);

      if (isAbsolute) return url.href;
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) {
      return value;
    }
  }

  function cleanCurrentUrl() {
    if (!nativeReplaceState) return;

    const url = new URL(window.location.href);
    if (!url.searchParams.has(LEGACY_PARAM)) return;

    url.searchParams.delete(LEGACY_PARAM);
    nativeReplaceState(
      window.history.state,
      '',
      `${url.pathname}${url.search}${url.hash}`
    );
  }

  function cleanLink(link) {
    if (!link?.getAttribute) return;
    const href = link.getAttribute('href');
    if (!href || !href.includes(`${LEGACY_PARAM}=`)) return;

    const cleaned = cleanUrl(href);
    if (cleaned && cleaned !== href) link.setAttribute('href', cleaned);
  }

  function cleanLinks(root = document) {
    if (root?.matches?.(`a[href*="${LEGACY_PARAM}="]`)) cleanLink(root);
    root?.querySelectorAll?.(`a[href*="${LEGACY_PARAM}="]`).forEach(cleanLink);
  }

  // Existing Loop code previously called history.replaceState to put the
  // bundle id back in the URL. Keep all other URL changes, but strip only
  // the legacy Loop parameter before they reach the address bar.
  if (nativeReplaceState) {
    window.history.replaceState = function (state, title, url) {
      return nativeReplaceState(state, title, url ? cleanUrl(url) : url);
    };
  }

  cleanCurrentUrl();
  cleanLinks(document);

  document.addEventListener('DOMContentLoaded', () => {
    cleanCurrentUrl();
    cleanLinks(document);
  }, { once: true });

  // Collection filtering/infinite loading can insert new product cards.
  // Observe added nodes only; do not observe attributes to avoid mutation loops.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) cleanLinks(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
